import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SessionProvider } from '../providers/session.provider';
import { Transaction } from '../transaction/transaction';
import { UseCaseWithParam } from './common/use.case.with.params';

export interface UpdateSessionUseCaseParams {
    token: string;
}

@Injectable()
export class UpdateSessionUseCase implements UseCaseWithParam<UpdateSessionUseCaseParams, Observable<Transaction<void>>> {
    constructor(private sessionProvider: SessionProvider) {}

    bind(params: UpdateSessionUseCaseParams): Observable<Transaction<void>> {
        return this.sessionProvider.update(params.token);
    }
}
